<template>
    <div>
                <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0" >Modify AIGC team members</h3>
                        </div>
                        <div class="card-body">
                           <form> <!--v-on:submit.prevent="onSubmit(title, message, );">-->

                         <fieldset class="form-group">
                            <div class="row">
                              <div class="col-md-6">
                               <h3>AIGC Team Members</h3>
                               <h5 style="color:#808080">Please tick the Team Members you want to remain assigned and keep the ones you want to unassign unticked.</h5>
                               <br>
                               <base-checkbox class="mb-3" v-for="(fieldName, pos1) in teammembers" :key="pos1" v-model="teammembers[pos1].checked">
                                      {{fieldName.name}}
                                  </base-checkbox>
                              </div>
                            </div>
                          </fieldset>

                            <fieldset class="form-group">
                            <div class="row">
                              <div class="col-md-6">
                                 <base-button type="success" v-on:click="onSubmit">{{buttontitle}}</base-button>
                              </div>
                            </div>
                          </fieldset>
                          </form>
<!--                                 <div class="col-lg-3 col-md-6"
                                     v-for="(icon, index) in icons" :key="icon.name + index">
                                    <button type="button"
                                            v-b-tooltip.hover.top
                                            :title="icon.name"
                                            v-clipboard:copy="icon.name"
                                            v-clipboard:success="onCopy"
                                            class="btn-icon-clipboard" data-clipboard-text="air-baloon">
                                        <div>
                                            <i :class="icon.name"></i>
                                            <span>{{icon.name.substring(6)}}</span>
                                        </div>
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import { mapState } from "vuex";
  import { GET_TEAM_MEMBERS, MODIFY_TEAM_MEMBERS } from "@/store/actions.type";
  import store from "@/store";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { mapGetters } from "vuex";
  import UserService from "@/common/user.service";
  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker},
    data() {
      return {
        report_type : "",
        buttontitle : 'Modify Members',
        teammembers : store.getters.teamMembers,
        note : '',
        budget : '',
        file : '',
        timeslot : 'Human Resources',
        message : '',
        tiers : {
          all : true,
          starter : false,
          silver : false,
          gold : false,
          platinum : false
        },
        dates: {
          simple: new Date().toISOString().split(" ")[0]
        }
      }
    },
    computed: {
      ...mapGetters(["isAuthenticated", "teamMembers"])
      // ,
      // subscribers() {
      //     console.log(this.$route.params.subscribers);
      //   return this.$route.params.subscribers;
      // }
    },
  mounted() {
    Promise.all([
      store.dispatch(GET_TEAM_MEMBERS,UserService.getAssignmentId())
    ]).then((data) => {
      console.log(data[0]['data']);
        this.loaded = true;

        console.log(store.getters.teamMembers);
        this.teammembers = data[0]['data'];
        // this.teammembers = teamMembers;
        // console.log(this.stores);
        // console.log(this.visitsdata);
        // this.initBigChart(this.stores[0]);
        // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
        // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
        // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
    });
  },
    methods: {


      onSubmit() {
        if (this.file !== '') {
          this.buttontitle = "Uploading..";
        }

        console.log("TITLE : " + this.title);
        // console.log("MESSAGE : " + this.message);
        // console.log("TIMESLOT : " + this.timeslot);
        // console.log("TIERS : ");
        // console.log(this.tiers);
        // console.log("DATE : " + this.dates.simple);
            // if (email !== '' && password !== '') {
            //     this.localerrors = null;

                let formData = {'team_members' : this.teammembers, 'assignment_id' : UserService.getAssignmentId()};

                Promise.all([
                  store.dispatch(MODIFY_TEAM_MEMBERS, formData),

                ]).then(() => {
                  this.$notify({
                    type: 'success',
                    title: 'Team Members Modified Successfully'
                  });
                    this.isLoading = false;
                    this.$router.push({ name: "overview" })
                });
            // }
            // else {

            //   this.localerrors = "Email or Password cannot be empty !"

            // }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },
      onChange(event) {
          this.timeslot = event.target.value;
          console.log(event);
      },
      onChangeRType(event) {
          this.report_type = event.target.value;
          console.log(event);
      },
      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      }
    }
  };
</script>
<style></style>
